"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionVideoAudioName = exports.PromotionVideoColorName = exports.PromotionVideoTemplateName = exports.PromotionApplication = exports.PromotionStatus = exports.TemplateCategoryStatus = exports.PromotionTemplateStatus = exports.PromotionTarget = exports.PromotionType = void 0;
var PromotionType;
(function (PromotionType) {
    /**
     * Percent off promotion when the promotion is a percentage discount.
     * {@example 10% off}
     */
    PromotionType["Discount"] = "DISCOUNT";
    /**
     * Fixed price promotion when the promotion is a fixed price discount
     * {@example $10 off}
     */
    PromotionType["SellingPrice"] = "SELLING_PRICE";
    /**
     * Before and after price promotion when the promotion is a before and after price
     * {@example $10 off, now $5}
     */
    PromotionType["Deal"] = "DEAL";
    /**
     * Label promotion when the promotion is a label
     * {@example SALE}
     */
    PromotionType["Label"] = "LABEL";
    /**
     * Free shipping for the order.
     */
    PromotionType["FreeShipping"] = "FREE_SHIPPING";
})(PromotionType || (exports.PromotionType = PromotionType = {}));
var PromotionTarget;
(function (PromotionTarget) {
    PromotionTarget["AllItems"] = "ALL_ITEMS";
    PromotionTarget["Items"] = "ITEMS";
    PromotionTarget["Category"] = "CATEGORY";
})(PromotionTarget || (exports.PromotionTarget = PromotionTarget = {}));
var PromotionTemplateStatus;
(function (PromotionTemplateStatus) {
    PromotionTemplateStatus["Active"] = "ACTIVE";
    PromotionTemplateStatus["Inactive"] = "INACTIVE";
})(PromotionTemplateStatus || (exports.PromotionTemplateStatus = PromotionTemplateStatus = {}));
var TemplateCategoryStatus;
(function (TemplateCategoryStatus) {
    TemplateCategoryStatus["Active"] = "ACTIVE";
    TemplateCategoryStatus["Inactive"] = "INACTIVE";
})(TemplateCategoryStatus || (exports.TemplateCategoryStatus = TemplateCategoryStatus = {}));
var PromotionStatus;
(function (PromotionStatus) {
    PromotionStatus["Active"] = "ACTIVE";
    PromotionStatus["Inactive"] = "INACTIVE";
})(PromotionStatus || (exports.PromotionStatus = PromotionStatus = {}));
var PromotionApplication;
(function (PromotionApplication) {
    PromotionApplication["AdGeneration"] = "AD_GENERATION";
    PromotionApplication["VideoGeneration"] = "VIDEO_GENERATION";
    PromotionApplication["StorefrontDisplay"] = "STOREFRONT_DISPLAY";
    PromotionApplication["OrderCoupon"] = "ORDER_COUPON";
})(PromotionApplication || (exports.PromotionApplication = PromotionApplication = {}));
/**
 * The value names are lowercased to match the enum values in the backend.
 */
var PromotionVideoTemplateName;
(function (PromotionVideoTemplateName) {
    PromotionVideoTemplateName["ThemeOne"] = "themeOne";
    PromotionVideoTemplateName["ThemeTwo"] = "themeTwo";
    PromotionVideoTemplateName["ThemeThree"] = "themeThree";
    PromotionVideoTemplateName["ThemeFour"] = "themeFour";
    PromotionVideoTemplateName["ThemeFive"] = "themeFive";
    PromotionVideoTemplateName["ThemeSix"] = "themeSix";
    PromotionVideoTemplateName["ThemeSeven"] = "themeSeven";
    PromotionVideoTemplateName["ThemeEight"] = "themeEight";
    PromotionVideoTemplateName["ThemeNine"] = "themeNine";
    PromotionVideoTemplateName["ThemeTen"] = "themeTen";
})(PromotionVideoTemplateName || (exports.PromotionVideoTemplateName = PromotionVideoTemplateName = {}));
var PromotionVideoColorName;
(function (PromotionVideoColorName) {
    PromotionVideoColorName["Yellow"] = "yellow";
    PromotionVideoColorName["Red"] = "red";
    PromotionVideoColorName["Black"] = "black";
    PromotionVideoColorName["Green"] = "green";
    PromotionVideoColorName["Blue"] = "blue";
    PromotionVideoColorName["White"] = "white";
})(PromotionVideoColorName || (exports.PromotionVideoColorName = PromotionVideoColorName = {}));
var PromotionVideoAudioName;
(function (PromotionVideoAudioName) {
    PromotionVideoAudioName["ThemeOne"] = "themeOne";
    PromotionVideoAudioName["ThemeTwo"] = "themeTwo";
    PromotionVideoAudioName["ThemeThree"] = "themeThree";
    PromotionVideoAudioName["ThemeFour"] = "themeFour";
    PromotionVideoAudioName["ThemeFive"] = "themeFive";
    PromotionVideoAudioName["ThemeSix"] = "themeSix";
})(PromotionVideoAudioName || (exports.PromotionVideoAudioName = PromotionVideoAudioName = {}));
//# sourceMappingURL=promotion.js.map